import React, { useRef, useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function WorkVideoModal({ open, onClose, videoSrc, caption }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (open && videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  }, [open]);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  const goFullscreen = () => {
    if (!videoRef.current) return;
    if (videoRef.current.requestFullscreen) videoRef.current.requestFullscreen();
  };

  /** Update seek value when video time changes */
  const updateProgress = () => {
    const v = videoRef.current;
    if (!v || !v.duration) return;
    setProgress((v.currentTime / v.duration) * 100);
  };

  /** Scrub using range input */
  const scrub = (e) => {
    const v = videoRef.current;
    if (!v) return;
    const pct = e.target.value;
    v.currentTime = (pct / 100) * v.duration;
    setProgress(pct);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="video-modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          {/* SHELL */}
          <motion.div
            className="video-modal-shell"
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.85, opacity: 0 }}
            onClick={(e) => e.stopPropagation()} // prevent backdrop close
          >
            {/* VIDEO CONTAINER */}
            <div className="video-modal-container">
              <video
                ref={videoRef}
                src={videoSrc}
                controls={false}
                muted={isMuted}
                onTimeUpdate={updateProgress}
                autoPlay
              />
            </div>

            {/* SEEK BAR */}
            <input
              type="range"
              className="video-seek"
              value={progress}
              onChange={scrub}
              min="0"
              max="100"
            />

            {/* CONTROLS */}
            <div className="video-controls">
              <button onClick={togglePlay}>
                {isPlaying ? "⏸" : "▶️"}
              </button>

              <button onClick={toggleMute}>
                {isMuted ? "🔇" : "🔊"}
              </button>

              <button onClick={goFullscreen}>
                ⛶
              </button>

              <button className="close-btn" onClick={onClose}>
                ✕
              </button>
            </div>

            {/* CAPTION */}
            {caption && <div className="video-modal-caption">{caption}</div>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
